import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/featuredPosts.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { supabase } from '../lib/supabase';

const FeaturedPosts = () => {
    const [featuredPosts, setFeaturedPosts] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        AOS.init({ duration: 800, easing: 'ease-in-out', once: true });

        const fetchFeaturedPosts = async () => {
            try {
                const { data: posts, error } = await supabase
                    .from('articles')
                    .select(`
                        id,
                        title,
                        description,
                        slug,
                        featured_image
                    `)
                    .eq('is_featured', true)
                    .order('published_at', { ascending: false });

                if (error) throw error; 

                if (posts && posts.length > 0) {
                    const formattedPosts = posts.map(post => ({
                        id: post.id,
                        title: post.title,
                        description: post.description,
                        slug: post.slug,
                        backgroundImage: post.featured_image
                            ? post.featured_image
                            : `/assets/featured-bg/${post.slug}.jpg, /assets/featured-bg/${post.slug}.png`
                    }));
                    setFeaturedPosts(formattedPosts);
                }
            } catch (error) {
                console.error('Error fetching featured posts:', error);
                setError(error.message);
            }
        };

        fetchFeaturedPosts();
    }, []);

    if (error) {
        return <div className="error-message">Error loading featured posts: {error}</div>;
    }

    return (
        <section className="featured-posts-section">
            <h2 className="featured-posts-title">Featured Articles</h2>
            <div className="featured-posts-container">
                {featuredPosts.map((post) => (
                    <Link
                        to={`/article/${post.slug}`}
                        key={post.id}
                        className="featured-post-card"
                        style={{
                            backgroundImage: post.backgroundImage.startsWith('http')
                                ? `url(${post.backgroundImage})`
                                : post.backgroundImage.split(', ').map(url => `url(${url})`).join(', '),
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                        }}
                        data-aos="fade-up"
                    >
                        <h3 className="featured-post-title">{post.title}</h3>
                        <div className="featured-post-meta">
                            {post.description}
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    );
};

export default FeaturedPosts;
